import React, { createContext, useState, useMemo } from "react";

export const DRContext = createContext();
const DEFAULT_TOTALS = {
  account: null,
  root: null,
  advisor_group: null,
  kyc: null,
};

export const DRProvider = ({ children }) => {
  const [loadedEntities, setLoadedEntities] = useState({});
  const [stateTotals, setStateTotals] = useState(DEFAULT_TOTALS);
  const [lastURL, setLastURL] = useState();

  const resetData = () => {
    setLoadedEntities({});
    setStateTotals(DEFAULT_TOTALS);
  };

  const contextObj = useMemo(
    () => ({
      loadedEntities,
      setEntities: setLoadedEntities,
      resetData,
      stateTotals,
      setTotals: setStateTotals,
      lastURL,
      setLastURL,
    }),
    // eslint-disable-next-line
    [loadedEntities, stateTotals]
  );
  return <DRContext.Provider value={contextObj}>{children}</DRContext.Provider>;
};
